import { Feature } from 'geojson';

import { FeatureTypeEnum } from '@/types/map.types';
import { ActivationAndFlightPlan } from '@/types/utm/flightPlan.types';

export const toFlightPlanFeatures = (activationAndFlightPlans: ActivationAndFlightPlan[]): Feature[] =>
  activationAndFlightPlans.map((activationAndFlightPlan) => ({
    type: 'Feature',
    id: `${FeatureTypeEnum.FLIGHT_PLAN}-${activationAndFlightPlan.activation.id}`,
    properties: {
      featureType: FeatureTypeEnum.FLIGHT_PLAN,
      activationId: activationAndFlightPlan.activation.id,
      name: activationAndFlightPlan.flightPlan.name,
      conflicts: activationAndFlightPlan.activation.conflicts,
    },
    geometry: activationAndFlightPlan.flightPlan.polygons,
  }));
